export var loadingContainerTheme = {
  baseStyle: _ref => {
    var {
      isLoading
    } = _ref;
    return {
      loadingContainer: {
        position: 'relative',
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'inherit'
      },
      loaderContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      childrenContainer: {
        height: '100%',
        opacity: isLoading ? 0 : 1,
        minHeight: 'inherit',
        display: 'flex',
        flexDirection: 'column'
      }
    };
  }
};
//# sourceMappingURL=LoadingContainer.theme.js.map